<template>
  <footer
    class="contain-content b-t b-grey-50 bg-white content-visibility-auto"
    style="contain-intrinsic-size: auto 100vw auto 51.875rem"
  >
    <div class="mx-a divide-y divide-grey-70" style="max-width: 90rem">
      <vf-footer-loyalty
        v-if="showLoyaltyFooter
          && $feature.enableLoyaltyFeatures
          && !user.isLoyaltyMember
          && !user.creditedConsumerProfileType
          && !user.isWranxOrIpaProfile"
      />
      <slot name="brightedge" />
      <vf-footer-columns />
      <div class="py-8 md:mx-4">
        <div
          v-style:w="{ md: '51rem' }"
          class="md:mx-a md:flex md:justify-center md:divide-x divide-grey-70 <md:divide-y"
        >
          <div v-style:w="{ md: '25.5rem' }" class="box-content px-4 md:pl-0 md:pr-8">
            <form-newsletter
              v-if="!hideNewsletter"
              class="w-full pb-8"
              class-heading="md:text-left"
              class-subheading="md:text-left text-sm"
              form-location="inline:footer:none:none"
              :show-hint="false"
            />
            <section
              class="pb-8 md:pb-0"
              :class="{ 'b-t b-grey-70 pt-8': !hideNewsletter }"
            >
              <div>
                <h2 class="mb-2 title-3">
                  {{ $t.footerContent.storeLocator.header }}
                </h2>
                <p class="mb-6 text-sm fw-light md:mb-4">
                  {{ $t.footerContent.storeLocator.description }}
                </p>
              </div>
              <vf-button
                class="<md:w-full"
                :size="{ sm: 'sm', md: 'xs' }"
                to="/store-locator"
                @click="$gtm.push('footer.onClickFooterLink', 'Store Locator')"
              >
                {{ $t.footerContent.storeLocator.button }}
              </vf-button>
            </section>
          </div>
          <div v-style:w="{ md: '25.5rem' }" class="f-col justify-center <md:w-full <md:px-4 <md:pt-8 divide-y divide-grey-70 md:pl-8">
            <section class="pb-8 md:pb-6 md:pr-0">
              <h2 class="mb-2 title-3">
                {{ $t.footerContent.social.header }}
              </h2>
              <div class="flex space-x-4 md:space-x-2">
                <div v-for="(to, name) in data?.links?.social" :key="name">
                  <base-link :aria-label="name" :to>
                    <vf-icon :name size="lg" />
                  </base-link>
                </div>
              </div>
            </section>
            <section v-if="appleStore && $feature.showAppStore" class="pt-8">
              <h2 class="mb-3 title-3">
                {{ $t.footerContent.appStores.header }}
              </h2>
              <base-link :to="appleStore.link">
                <base-picture
                  :alt="appleStore.alt"
                  height="36"
                  :props-img="{ class: 'w-full' }"
                  :src="appleStore.icon"
                  style="height: 2.25rem"
                  width="108"
                />
              </base-link>
            </section>
          </div>
        </div>
      </div>
      <vf-footer-legal-links v-if="data?.links?.legal" class="o:mx-0" :links="data.links.legal">
        <base-link class="<md:hidden" to="/">
          <vf-logo loading="lazy" style="max-width: 7.5rem" />
        </base-link>
      </vf-footer-legal-links>
    </div>
  </footer>
</template>

<script lang="ts" setup>
defineProps<{
  hideNewsletter?: boolean
}>()

const { data } = await useApi().internal.getFooter()

const { showLoyaltyFooter } = useAppConfig().components.vf.footer

const user = useUserStore()

const appleStore = computed(() => data.value?.links?.appStores?.find(({ name }) => name === 'appleStore'))
</script>
